import { WeatherShareIcon, WeatherDisplayIcon, WeatherRemoveIcon } from '@/resource/IconComponentSets';
import { IWeatherStationReqModel } from '@/util/Request/requestType';
import React, { useEffect, useState } from 'react';
import './index.less';

interface IProps {
    removeButtonClicked?: (queryId: string) => void
    displayButtonClicked?: (queryId: string) => void
    shareButtonClicked?: (queryId: string) => void
    data: IWeatherStationReqModel
}

const WeatherQueryRecord = (props: IProps) => {
    const {
        removeButtonClicked,
        displayButtonClicked,
        shareButtonClicked,
        data
    } = props;

    const [title, setTitle] = useState('Name');
    const [locationLength, setLocationLength] = useState(0);
    const [locationListStr, setLocationListStr] = useState<string>('');

    useEffect(() => {
        if (data) {
            setTitle(data.queryName);

            switch(data.tabName) {
                case 'Name': {
                    setLocationLength(data.locations.length);
                    const locationArr = data.locations.map((location) => location.name);
                    setLocationListStr(locationArr.join(' ; '));
                    break;
                }
                case 'Coordinates': {
                    setLocationLength(data.coordinates.length);
                    const coordinateArr = data.coordinates.map((coordinate) => `longitude: ${coordinate.longitude}, latitude: ${coordinate.latitude}`);
                    setLocationListStr(coordinateArr.join(' ; '));
                    break;
                }
                case 'Administrative areas': {
                    setLocationLength(data.politicalAreas.length);
                    const locationStr = data.politicalAreas.map(political => `${political.region}${political.country && '/'}${political.country}${political.state && '/'}
                    ${political.state}${political.cityname && '/'}${political.cityname}`);
                    setLocationListStr(locationStr.join(','));
                    break;
                }
                case 'Draw on map': {
                    setLocationLength(1);
                    setLocationListStr(data.geometryText);
                    break;
                }
                case 'Station': {
                    setLocationLength(0);
                    // setLocationListStr(data);
                }
            }
        }
    }, [data]);

    return (
        <div className='weather-query-record-container'>
            <div className='query-title-div'>
                <p>{title}</p>
                <p>
                    {data.lastDate}
                </p>
            </div>
            <div className='all-location-div'>
                <p>Location({locationLength})</p>
                <p className='location-p'>{locationListStr}</p>
            </div>
            <div className='all-location-div '>
                <p>Properties({data.hierarchies.length})</p>
                {
                    data.hierarchies.map((hierarchy) => (
                        <p key={`${hierarchy.supplier}-${hierarchy.variable}-${hierarchy.frequency}`}>
                            {hierarchy.supplier}/{hierarchy.variable}/{hierarchy.frequency}
                        </p>
                    ))
                }
            </div>
            <div className='weather-operation-div'>
                <button onClick={() => removeButtonClicked(data.queryId) }><WeatherRemoveIcon /></button>
                <button onClick={() => displayButtonClicked(data.queryId) }><WeatherDisplayIcon /></button>
                <button onClick={() => shareButtonClicked(data.queryId) }><WeatherShareIcon /></button>
            </div>
        </div>
    );
};

export default WeatherQueryRecord;
